module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contract-manage"
  }, [_c('banner', {
    attrs: {
      "clazz": "contract-manage-banner",
      "url": "contractManage"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goRegister('hetongguanli-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")])], 1)], 2), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contract-manage-section3"
  }, [_c('div', {
    staticClass: "section3-content"
  }, [_c('h1', {
    staticClass: "section3-title"
  }, [_vm._v("合同管理为何至关重要？")]), _vm._v(" "), _c('div', {
    staticClass: "section3-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section3-main"
  }, [_c('div', {
    staticClass: "section3-choose"
  }, [_c('ul', {
    staticClass: "section3-ul clearfix"
  }, _vm._l((_vm.section3Data), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "section3-li fl"
    }, [_c('div', [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.src),
        expression: "item.src"
      }],
      attrs: {
        "alt": item.title
      }
    })]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.title.replace(/@/g, '<br/>'))
      }
    })])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "contract-manage-section4"
  }, [_c('div', {
    staticClass: "section4-above"
  }), _vm._v(" "), _c('div', {
    staticClass: "section4-under"
  }), _vm._v(" "), _c('div', {
    staticClass: "section4-content"
  }, [_c('h1', {
    staticClass: "section4-title"
  }, [_vm._v("甄云合同管理，将您的合同转换为动态商业工具和社交管理工具")]), _vm._v(" "), _c('div', {
    staticClass: "section4-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "section4-main"
  }, [_c('el-tabs', {
    staticClass: "contract-manage-tab",
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', [_c('div', {
    staticClass: "contract-manage-tabpane",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("简化合同创建")]), _vm._v(" "), _c('div', {
    staticClass: "main-region"
  }, [_c('div', {
    staticClass: "contents-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/contractManage/1bg1.png"),
      "alt": "简化合同创建"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contents-content"
  }, [_c('h1', {
    staticClass: "contents-title"
  }, [_vm._v("\n                  甄云合同管理采用预先批准的条款库、模板和审批工作流，"), _c('br'), _vm._v("\n                  帮助您创建标准化的合同\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("使用引导式设计向导简化合同创建\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("支持线下自定义合同模板，上传至系统；支持多模板管理\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("支持合同模板、合同文本进行多用户在线协同编辑，并可控"), _c('br'), _vm._v("\n                      制不同用户编辑权限\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("确保合同符合公司政策以及法律条款和条件\n                ")]), _vm._v(" "), _c('hover-button', {
    attrs: {
      "text": "申请试用",
      "clazz": "consult-button dib",
      "duration": 0.5
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTrial('hetongguanli-gongju-jianhua')
      }
    }
  })], 1)])]), _vm._v(" "), _c('el-tab-pane', [_c('div', {
    staticClass: "contract-manage-tabpane",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("增强可见性")]), _vm._v(" "), _c('div', {
    staticClass: "main-region"
  }, [_c('div', {
    staticClass: "contents-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/contractManage/2bg2.png"),
      "alt": "增强可见性"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contents-content"
  }, [_c('h1', {
    staticClass: "contents-title"
  }, [_vm._v("\n                  采用安全、可搜索的信息库，拥有完整的审计历史记录\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("识别偏离标准的更改并分配所需的操作\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("通过丰富的搜索功能快速找到您需要的内容\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("使用工作区快速找到审查和批准等需要注意的项目\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("标签替换：创建合同时根据模板标签，自动替换合同条款关键"), _c('br'), _vm._v("\n                      字段\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("通过社交协作和工作流简化审查周期\n                ")]), _vm._v(" "), _c('hover-button', {
    attrs: {
      "text": "申请试用",
      "clazz": "consult-button dib",
      "duration": 0.5
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTrial('hetongguanli-gongju-zengqiang')
      }
    }
  })], 1)])]), _vm._v(" "), _c('el-tab-pane', [_c('div', {
    staticClass: "contract-manage-tabpane",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("电子签章")]), _vm._v(" "), _c('div', {
    staticClass: "main-region"
  }, [_c('div', {
    staticClass: "contents-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/contractManage/3bg3.png"),
      "alt": "电子签章"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contents-content"
  }, [_c('h1', {
    staticClass: "contents-title"
  }, [_vm._v("简单，可见，可审计")]), _vm._v(" "), _c('div', {
    staticClass: "contents-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("CA认证：在线验证企业信息三要素，申请CA证书；同时支持"), _c('br'), _vm._v("\n                      自定义印章，进行多印章管理\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "contents-detail"
  }, [_c('span', {
    staticClass: "detail-bar"
  }), _vm._v("电子签章：通过SRM申请CA认证，签署时调用电子签章进行"), _c('br'), _vm._v("\n                      签署\n                ")]), _vm._v(" "), _c('hover-button', {
    attrs: {
      "text": "申请试用",
      "clazz": "consult-button dib",
      "duration": 0.5
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTrial('hetongguanli-gongju-qianzhang')
      }
    }
  })], 1)])])], 1)], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contract-manage-section1"
  }, [_c('div', {
    staticClass: "section1-content clearfix"
  }, [_c('img', {
    staticClass: "section1-img fl",
    attrs: {
      "src": require("../../assets/img/contractManage/1peitu.png"),
      "alt": "实现所有端到端合同的协作化"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section1-misc fr"
  }, [_c('h1', {
    staticClass: "misc-title"
  }, [_vm._v("实现所有端到端合同的协作化，无纸化和无缝化")]), _vm._v(" "), _c('div', {
    staticClass: "misc-divider"
  }), _vm._v(" "), _c('p', {
    staticClass: "misc-content"
  }, [_vm._v("\n          甄云合同管理，支持线下上传，线上多方协作编辑，简化日常搜索"), _c('br'), _vm._v("\n          呈现合同实时数据，为所有用户提供从采购到法律到销售的可见性，"), _c('br'), _vm._v("\n          将每份合同都变成一个强大的决策工具。\n        ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-294b5abd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/contractManage.vue
// module id = 472
// module chunks = 12